import { Buttons } from "@/components/atoms/Buttons";
import { SideMenu } from "@/components/organisms/SideMenu";
import { useNavigate } from "react-router";
import { MainTemplate } from "@/components/templates/MainTemplate";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow.svg";

export const SettingPage = () => {
  const navigate = useNavigate();

  return (
    <MainTemplate
      nav={false}
      subPage={false}
      menuBtn={false}
      pageTitle="설정"
      buttonLeft={
        <Buttons
          type="button"
          size="headerTextIcon"
          layout="text"
          color="bright100"
          icon={<IconArrow />}
          label="홈"
          onClick={() => navigate("/home")}
        />
      }
    >
      <SideMenu version="1.1.2" />
    </MainTemplate>
  );
};
